/**
 * @flow
 * @relayHash 68a3fd1fbbb21e0fb01fc51f041ee34a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CurrencySettingsQueryVariables = {||};
export type CurrencySettingsQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +company: {|
      +id: string,
      +currency: string,
    |},
  |}
|};
export type CurrencySettingsQuery = {|
  variables: CurrencySettingsQueryVariables,
  response: CurrencySettingsQueryResponse,
|};
*/


/*
query CurrencySettingsQuery {
  viewer {
    id
    company {
      id
      currency
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "company",
        "storageKey": null,
        "args": null,
        "concreteType": "Company",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "currency",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CurrencySettingsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CurrencySettingsQuery",
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "CurrencySettingsQuery",
    "id": null,
    "text": "query CurrencySettingsQuery {\n  viewer {\n    id\n    company {\n      id\n      currency\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ba56bb12316270f5618be07fb7bfa3e0';
module.exports = node;
